.wrapper {
  padding: 24px 0;
}

.container {
  background: var(--main-background);
  width: 100%;
  max-width: 1200px;
  min-width: 650px;
  margin: 0 auto;
  padding: 10px 20px;
  box-sizing: border-box;
  border-radius: 8px;
  white-space: pre-wrap;
}

@media (max-width: 600px) {
  .container {
    padding: 10px 15px;
    min-width: unset;
    width: 100%;
  }

  .header {
    flex-direction: column;
    gap: 12px;
  }

  .actions {
    margin-left: 0;
    align-self: flex-start;
  }
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
  padding: 16px 0;
  border-bottom: 1px solid #e0e0e0;
}

.titleSection {
  flex: 1;
}

.actions {
  display: flex;
  align-items: center;
  margin-left: 16px;
}

.title {
  font-size: var(--font-size-title);
  font-weight: 600;
  color: var(--main-text);
  margin: 0 0 8px 0;
  line-height: 1.2;
}

.subtitle {
  font-size: var(--font-size-subtitle);
  color: var(--body-text);
  margin: 0;
  line-height: 1.4;
}

.eventHeader {
  margin-bottom: 24px;
  padding: 16px;
  background-color: var(--light-purple);
  border: 0.5px solid var(--purple);
  border-radius: 8px;
}

.eventTitle {
  font-size: 18px;
  font-weight: 600;
  color: var(--main-text);
  margin: 0 0 8px 0;
  line-height: 1.4;
}

.eventTitleLink {
  color: inherit;
  text-decoration: none;
  transition: color 0.2s ease;
}

.eventTitleLink:hover {
  color: #535bf2;
  text-decoration: none;
}

.eventDate {
  font-size: 14px;
  color: var(--gentle-grey);
  margin: 0;
}

.eventInfo {
  flex: 1;
}

.summary {
  margin-bottom: 24px;
}

.summaryTitle {
  font-size: 16px;
  font-weight: 600;
  color: var(--main-text);
  margin: 0 0 8px 0;
}

.summaryText {
  font-size: var(--font-size-body);
  color: var(--main-text);
  margin: 0;
  line-height: 1.5;
}

.summaryContent {
  font-size: var(--font-size-body);
  color: var(--main-text);
  line-height: 1.5;
}

.summaryContent p {
  margin: 0 0 12px 0;
}

.summaryContent p:last-child {
  margin-bottom: 0;
}

/* Inline Event Pills */
.contentWithEvents {
  display: block;
}

.markdownContent {
  display: inline;
}

.markdownContent p {
  display: inline;
  margin: 0;
}

.inlineEvents {
  display: inline;
}

.analysis {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.analysisDate {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid var(--light-grey);
  text-align: center;
}

.analysisDate p {
  color: var(--body-text);
  font-size: 12px;
  margin: 0;
  font-style: italic;
}

.section {
  border-bottom: 1px solid var(--light-grey);
  padding-bottom: 16px;
}

.section:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.sectionHeading {
  font-size: 16px;
  font-weight: 600;
  color: var(--main-text);
  margin: 0 0 12px 0;
}

.contentItem {
  margin-bottom: 12px;
}

.contentItem:last-child {
  margin-bottom: 0;
}

.paragraph p {
  font-size: var(--font-size-body);
  color: var(--main-text);
  margin: 0;
  line-height: 1.5;
}

.insight {
  padding: 12px;
  background-color: rgba(251, 208, 101, 0.1);
  border: 1px solid rgba(251, 208, 101, 0.1);
  border-radius: 4px;
  position: relative;
}

.insight p {
  font-size: 15px;
  color: var(--main-text);
  margin: 0;
  line-height: 1.5;
  font-style: italic;
  padding-left: 32px;
}

.insightIcon {
  position: absolute;
  top: 12px;
  left: 12px;
  color: var(--gold);
  font-size: 16px;
}

/* Loading skeleton styles */
.loadingSkeleton {
  padding: 16px;
}

.skeletonEventHeader {
  margin-bottom: 16px;
  border-radius: 8px;
}

.skeletonTitle {
  margin-bottom: 8px;
}

.skeletonText {
  margin-bottom: 4px;
}

.topicHeader {
  position: relative;
  margin: 0 0 24px 0;
  padding: 16px;
  background-color: var(--light-purple);
  border: 0.5px solid var(--purple);
  border-radius: 8px;
}

.topicInput {
  font-size: 16px;
  color: var(--main-text);
  margin: 0;
  line-height: 1.5;
  font-weight: 500;
  font-style: italic;
  position: relative;
  text-indent: 32px;
}

.quoteIcon {
  position: absolute;
  top: 8px;
  left: 8px;
  font-size: 32px !important;
  color: var(--purple) !important;
  width: 32px;
  height: 32px;
  transform: scaleX(-1);
}

@media print {
  .actions {
    display: none !important;
  }

  .insight {
    border: 1px solid rgba(251, 208, 101, 0.5);
  }
}
